import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import moment from'moment';
import { MessageInformationnelModel } from 'src/models/message-informationnel-model';
import { MessageInformationService } from 'src/services/message-information.service';

@Component({
    selector: 'app-message-information',
    templateUrl: './message-information.component.html',
    styleUrls: ['./message-information.component.scss'],
    imports: []
})
export class MessageInformationComponent implements OnInit {
  showMessage!: boolean;
  messageInformations: MessageInformationnelModel[] = [];
  constructor(private message: MessageInformationService, private translateService: TranslateService) { }

  ngOnInit() {
    this.obtenirMessageInformation();
  }

 obtenirMessageInformation() {
    const codeLangue = this.translateService.currentLang || 'fr';
    this.message.getMessages(codeLangue).subscribe((reponse) => {
      this.messageInformations = reponse;
      this.showMessage = this.messageInformations.length > 0 ;
    });
  }
}
